import Layout from "@/components/layout/Layout";
import React from "react";
import Content from "@/components/layout/Content";
import ContentOptions from "@/components/layout/ContentOptions";
import Heading from "@/components/elements/Heading";
import Sidepanel from "@/components/layout/Sidepanel";
import { InertiaLink } from "@inertiajs/inertia-react";
import DashboardMenu from "@/pages/Dashboard/DashboardMenu";

/**
 * Colors Dashboard Component
 *
 * Displays a table of all available colors in the system with their properties.
 * Provides navigation to create new colors and edit existing ones.
 * Part of the admin dashboard interface for managing color definitions.
 *
 * @param {Object} props - Component props
 * @param {Array} props.colors - Array of color objects to display
 * @param {string} props.colors[].id - Unique color identifier
 * @param {string} props.colors[].ral - RAL color code
 * @param {string} props.colors[].trespa - Trespa color code
 * @param {string} props.colors[].hex - Hex color value
 * @param {string} props.colors[].levertijd - Delivery time information
 * @param {boolean} props.colors[].extern - Whether color is visible to external customers
 *
 * @returns {JSX.Element} The rendered colors dashboard page
 */
export default function Colors({ colors }) {
    return (
        <Layout>
            <Sidepanel>
                <DashboardMenu active={"Kleuren"} />
            </Sidepanel>
            <Content>
                <ContentOptions small>
                    <Heading heading={"Kleuren"} />
                </ContentOptions>
                <div
                    className={`contentoptions ingaveoptions col-md-9 d-flex flex-column`}
                >
                    <Heading heading="Kleuren">
                        <div>
                            <a
                                name={"Nieuwe kleur"}
                                href="/dashboard/colors/new"
                                className="btn-orange"
                            >
                                Nieuwe kleur
                            </a>
                        </div>
                    </Heading>

                    <table className="table tablecustom">
                        <thead>
                            <tr>
                                <th>Ral</th>
                                <th>Trespa</th>
                                <th>Hex</th>
                                <th>Levertijd</th>
                                <th>Extern</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {colors.map((color, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{color.ral}</td>
                                        <td>{color.trespa}</td>
                                        <td>{color.hex}</td>
                                        <td>{color.levertijd}</td>
                                        <td>{color.extern}</td>
                                        <th>
                                            <InertiaLink
                                                name={"Aanpassen"}
                                                href={`/dashboard/colors/edit/${color.id}`}
                                                className={"mr-2"}
                                            >
                                                <svg
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                    height="20"
                                                >
                                                    <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </InertiaLink>
                                        </th>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Content>
        </Layout>
    );
}
